import React from 'react';
export function QuickTaskSection() {
  return <div className="w-full max-w-[1400px] mt-16 px-4" data-id="element-330">
      {/* Feature Card */}
      <div className="bg-blue-900 rounded-3xl overflow-hidden shadow-2xl p-8 md:p-12" data-id="element-331">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center" data-id="element-332">
          {/* Text Content */}
          <div className="text-white" data-id="element-333">
            <h3 className="text-3xl md:text-5xl font-bold mb-6 leading-tight" data-id="element-334">
              Fast & Automatic Peeling
            </h3>
            <p className="text-lg md:text-xl leading-relaxed" data-id="element-335">
              With a single press, the machine peels apples, pears, potatoes,
              and more in seconds. No more dull prep work—meal preparation
              becomes faster, smoother, and even a bit fun, especially when the
              whole family gathers in the kitchen.
            </p>
          </div>

          {/* Image - Single image without white borders */}
          <div className="relative" data-id="element-336">
            <img src="https://cdn.magicpatterns.com/uploads/usMqAKjpskFZ7yfP8vD3kk/image.png" alt="Automatic peeling machine with product images" className="w-full h-auto rounded-2xl shadow-lg" data-id="element-337" />
          </div>
        </div>
      </div>
    </div>;
}